import { TableCell } from 'src/components/atoms'
import { TableSortableTxt, TableSortType } from 'src/components/molecules'

export type ExternalAssignUserSortItemType =
  | 'name'
  | 'email'
  | 'keywords'
  | 'customRole'
  | 'assignedAt'
  | 'compassRole'

type Props = {
  sortItem: ExternalAssignUserSortItemType
  sortType: TableSortType
  onSelectItem: (newItem: ExternalAssignUserSortItemType) => void
  onSelectSortType: (newType: TableSortType) => void
  className?: string
}

export function ExternalAssignUserTableHead({
  sortItem,
  sortType,
  onSelectItem,
  onSelectSortType,
  className,
}: Props) {
  const handleOnSelectItem = (newItem: ExternalAssignUserSortItemType) => {
    if (sortItem === newItem) {
      onSelectSortType(sortType === 'asc' ? 'desc' : 'asc')
    } else {
      onSelectItem(newItem)
    }
  }

  return (
    <div className={className}>
      <div className="tw-flex tw-gap-s0 tw-bg-surface-secondary tw-border tw-border-border-secondary tw-rounded-t-[8px] tw-py-s-1 tw-px-s0">
        <TableCell className="tw-w-full tw-shrink">
          <TableSortableTxt
            text="名前"
            isActive={sortItem === 'name'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('name')}
          />
        </TableCell>
        <TableCell width={20}>
          <TableSortableTxt
            text="メールアドレス"
            isActive={sortItem === 'email'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('email')}
          />
        </TableCell>
        <TableCell width={20}>
          <TableSortableTxt
            text="キーワード"
            isActive={sortItem === 'keywords'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('keywords')}
          />
        </TableCell>
        <TableCell width={20}>
          <TableSortableTxt
            text="アサイン日"
            isActive={sortItem === 'assignedAt'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('assignedAt')}
          />
        </TableCell>
        <TableCell width={20}>
          <TableSortableTxt
            text="ROOV compass権限"
            isActive={sortItem === 'compassRole'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('compassRole')}
          />
        </TableCell>
      </div>
    </div>
  )
}
